export default __webpack_public_path__ + "static/erich-gamma-524b6655b95f6157ffcf235cddca512f.jpg";